import { render } from "./SkillsSection.vue?vue&type=template&id=6016e039&scoped=true&lang=true"
import script from "./SkillsSection.vue?vue&type=script&lang=js"
export * from "./SkillsSection.vue?vue&type=script&lang=js"

import "./SkillsSection.vue?vue&type=style&index=0&id=6016e039&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6016e039"]])

export default __exports__